/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import CurrentRoamPlanCard from './index/current-roam-plan-card';
import { hasScheduledChanges } from 'state/current-roam/selectors';
import ScheduledChangesCard from './index/scheduled-changes';
import RoamDetailsCard from './index/roam-details-card';
import { Stack, Box } from '@towersystems/towersystems-design-system';
import AnnotatedSection from 'components/annotated-section';

/**
 * Style dependencies
 */
import './styles.scss';

const Roam = (props) => {
    return (
        <Box>
            <DocumentHead title='Billing - Manage Roam Plan - Tower Systems' />
            <Topbar title='Roam Plan' subTitle='Manage your roam plan' selected='roam'>

            </Topbar>
            <Main padding='xxlarge'>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Subscription Details'
                            description='Your current roam plan details.'
                        />
                        <AnnotatedSection.Content>
                            <CurrentRoamPlanCard />
                            {props.hasScheduledChanges && <ScheduledChangesCard />}
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
        hasScheduledChanges: hasScheduledChanges(state),
    }),
    {},
)(Roam);
